import { mapGetters } from 'vuex';
export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters('auth', ['getAuthenticatedUser', 'getActiveWorkspace']),
    ...mapGetters('paymentGateway', ['getPaymentsHistory', 'getPlansFeatures']),
  },
  methods: {
    async getPlanExpireDetails() {
      return true;
    },
    async getSubscriptionHistory() {
      try {
        let email = 'info@esigns.io';
        await this.$store.dispatch('paymentGateway/fetchSubscriptionInfo', { email });
        //this.getPlanExpireDetails();
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
